import type {Dispatch} from 'react'
import {Switch as RacSwitch, type SwitchProps} from 'react-aria-components'

import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './Switch.module.scss'

interface Props {
  label: string | ReactNode
  onChange?: Dispatch<boolean>
  labelClassName?: string | ReactNode
  isLabelVisible?: boolean
}

export default memo<Omit<SwitchProps, 'children' | 'onChange'> & Props>(function Switch(props) {
  return (
    <RacSwitch {...props} className={clsx(style.Switch, props.className)}>
      <div className={style.SwitchHandleContainer}>
        <div className={style.SwitchHandle} />
      </div>
      <VisuallyHidden
        as='span'
        isVisible={!!props.isLabelVisible}
        className={clsx(style.SwitchLabel, props.labelClassName)}
      >
        {props.label}
      </VisuallyHidden>
    </RacSwitch>
  )
})
